<template>
  <div class="app-crud-tab__tab">
    <!-- <div class="app-crud-tab__warp flex justify-between align-center">
      <label v-if="title" class="ioc-crud__searchbar__title ml-2">{{ title }}</label>
      <div>
        <template v-if="options.length">
          <div v-for="(item, index) in options" :key="index" class="app-crud-tab__item" @click="handleClick(item)" :class="currentTab.prop == item.prop ? 'active' : ''">
            {{ item.label }}
          </div>
        </template>
      </div>

      <div v-if="isShowSearch" class="ioc-crud__searchbar__arrow mr-2" @click="handleBarShow">
        <label>{{ barShow ? '收起' : '展开' }}</label>
        <div class="ioc-crud__searchbar__arrow__icon" :class="barShow ? '' : 'expand'">
          <i class="el-icon-arrow-up"></i>
        </div>
      </div>
    </div> -->
    <div class="ioc-crud__search" v-if="barShow && isShowSearch" style="padding: 18px 15px 0;background: #fff;">
      <slot name="form" />
    </div>
    <div class="ioc-crud__interval"></div>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: function(){
        return []
      }
    },
    isShowSearch: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tabs: [],
      currentTab: {},
      barShow: true
    }
  },
  watch: {
    options(val) {
      // this.currentTab = this.options[0]
    }
  },
  mounted() {
    this.currentTab = this.options[0]
  },
  methods: {
    handleClick(item) {
      this.currentTab = item
      this.$emit('clickTab', item)
    },
    handleBarShow() {
      this.barShow = !this.barShow
    }
  }
}
</script>
